import { render, staticRenderFns } from "./TripsHistoryTable.vue?vue&type=template&id=0f5730f5&scoped=true&"
import script from "./TripsHistoryTable.vue?vue&type=script&lang=js&"
export * from "./TripsHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./TripsHistoryTable.vue?vue&type=style&index=0&id=0f5730f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5730f5",
  null
  
)

export default component.exports